import { render, staticRenderFns } from "./yearpay.vue?vue&type=template&id=224795e7&scoped=true&"
import script from "./yearpay.vue?vue&type=script&lang=js&"
export * from "./yearpay.vue?vue&type=script&lang=js&"
import style0 from "./yearpay.vue?vue&type=style&index=0&id=224795e7&lang=less&scoped=true&"
import style1 from "./yearpay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224795e7",
  null
  
)

export default component.exports